<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <md-card style="min-height: 520px">
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousStockInView"
              >&laquo; Back</md-button
            >
          </md-layout>
          <md-layout md-flex="30"></md-layout>
          <md-layout md-flex="40">
            <h3>
              <b>{{ editVar.FormVal }} Stock In</b>
            </h3>
          </md-layout>
        </md-layout>

        <hr class="hr-s" />

        <b-row>
          <b-col md="4">
            <label for="poNumberAll">PO Number</label>
            <model-list-select
              v-if="stockInDetails.stockInId == ''"
              :list="poMasterList"
              v-model="poNumberAll"
              :isDisabled="stockInDetails.stockInId == '' ? false : true"
              option-value="poOrderId"
              option-text="poOrderSeries"
              placeholder="Select PO Number"
              @input="getVendorDetails(poNumberAll)"
            ></model-list-select>
            <b-form-input
              :formatter="capitalizeAll"
              v-else
              id="poNumber"
              name="poNumber"
              v-model="stockInDetails.poNumber"
              disabled
            ></b-form-input>
            <h5
              v-if="this.stockInDetails.poNumber != ''"
              class="showMoreData float-left success mt-2"
              @click="showMore"
            >
              Click here {{ showMoreNew == true ? " to hide" : " for more" }} PO Details
            </h5>
          </b-col>
        </b-row>
        <b-row v-if="showMoreNew == true">
          <b-col md="4">
            <label>Added By</label>
            <b-form-input
              :formatter="capitalizeAll"
              id="addedByPerson"
              name="addedByPerson"
              v-model="stockInDetails.addedByPerson"
              disabled
            ></b-form-input>
          </b-col>

          <b-col md="4">
            <label for="maintenanceType">Maintenance Type</label>
            <model-list-select
              :list="MaintainList"
              isDisabled
              v-model="stockInDetails.maintenanceType"
              option-value="MVal"
              option-text="MText"
              placeholder="Select  Type"
            ></model-list-select>
          </b-col>
          <b-col md="4">
            <label>PO Date</label>
            <b-form-input
              :formatter="capitalizeAll"
              id="poDate"
              name="poDate"
              v-model="stockInDetails.poDate"
              disabled
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-4" v-if="showMoreNew == true">
          <b-col md="12">
            <label>Specific Details on PO,if any..</label>
            <b-form-input
              :formatter="capitalizeAll"
              id="specificPoDetail"
              name="specificPoDetail"
              v-model="stockInDetails.specificPoDetail"
              disabled
            ></b-form-input>
          </b-col>
        </b-row>

        <hr class="hr-border" />

        <div v-if="this.stockInDetails.poNumber != ''">
          <b-row class="mb-3">
            <b-col md="4">
              <!-- {{$store.getters['commonDropdownMaster/getAllTallyVendorList']}}
              {{ stockInDetails.vendorName }} -->
              <label for="vendorName">Vendor Name</label>
              <model-list-select
                :list="$store.getters['commonDropdownMaster/getAllTallyVendorList']"
                hidden
                isDisabled
                id="vendorName"
                name="vendorName"
                v-model="stockInDetails.vendorName"
                option-value="value"
                option-text="label"
                placeholder="Select Vendor"
              ></model-list-select>
              <!-- <model-list-select
                :list="vendorMaster"
                hidden
                isDisabled
                v-model="stockInDetails.vendorName"
                option-value="refuelStationId"
                option-text="vendorName"
                placeholder="Select Vendor"
              ></model-list-select> -->
              <span class="error" v-if="!stockInDetails.vendorName">{{
                vendorNamError
              }}</span>

              <b-form-input disabled v-model="vendorNameDisplay"></b-form-input>
            </b-col>

            <b-col md="4">
              <label>Invoice No.</label>
              <b-form-input
                :formatter="capitalizeAll"
                id="invoiceNo"
                name="invoiceNo"
                v-model="stockInDetails.invoiceNo"
              ></b-form-input>
              <span class="error" v-if="!stockInDetails.invoiceNo">{{
                invoiceNoError
              }}</span>
            </b-col>

            <b-col md="4">
              <label>Invoice Amount</label>
              <b-form-input
                :formatter="capitalizeAll"
                id="invoiceAmount"
                name="invoiceAmount"
                v-model="stockInDetails.invoiceAmount"
              ></b-form-input>
              <span class="error" v-if="!stockInDetails.invoiceAmount">{{
                invoiceAmountError
              }}</span>
            </b-col>
          </b-row>

          <hr class="hr-border" />

          <b-row>
            <b-col md="2">
              <label class="w-100">Stock Received Date</label>
              <date-picker
                :format="selectDateFormat"
                lang="en"
                v-model="stockInDetails.stockReceivedDate"
                id="Date"
              ></date-picker>
              <br />
              <span class="error" v-if="!stockInDetails.stockReceivedDate">{{
                stockReceivedDateError
              }}</span>
            </b-col>

            <b-col md="2">
              <label class="w-100">Stock-In Date</label>
              <date-picker
                :format="selectDateFormat"
                lang="en"
                v-model="stockInDetails.stockInDate"
                id="stockInDate"
              ></date-picker>
              <br />
              <span class="error" v-if="!stockInDetails.stockInDate">{{
                stockInDateError
              }}</span>
            </b-col>

            <b-col md="2">
              <label>Stock Received By</label>
              <model-list-select
                :list="employeeMasterList"
                v-model="stockInDetails.stockReceivedBy"
                option-value="employeeName"
                option-text="employeeName"
                placeholder="Select "
                id="stockReceivedBy"
              ></model-list-select>
              <span class="error" v-if="!stockInDetails.stockReceivedBy">{{
                stockReceivedByError
              }}</span>
            </b-col>

            <b-col md="2">
              <label>Stock Checked By</label>
              <model-list-select
                :list="employeeMasterList"
                v-model="stockInDetails.stockCheckedBy"
                option-value="employeeName"
                option-text="employeeName"
                placeholder="Select "
                id="stockCheckedBy"
              ></model-list-select>
              <span class="error" v-if="!stockInDetails.stockCheckedBy">{{
                stockCheckedByError
              }}</span>
            </b-col>

            <b-col md="2">
              <label for="qualityCheck">Quality Check Done ?</label>
              <model-list-select
                :list="qualityList"
                v-model="stockInDetails.qualityCheck"
                option-value="qVal"
                option-text="qText"
                placeholder="Select Yes/No "
              ></model-list-select>
              <span class="error" v-if="!stockInDetails.qualityCheck">{{
                qualityCheckError
              }}</span>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <label>Goods Status</label>
              <b-form-textarea
                :formatter="capitalizeAll"
                id="goodsStatus"
                name="goodsStatus"
                v-model="stockInDetails.goodsStatus"
              ></b-form-textarea>
              <span class="error" v-if="!stockInDetails.goodsStatus">{{
                goodsStatusError
              }}</span>
            </b-col>

            <b-col md="6">
              <label>Faulty Goods Details if any.!</label>
              <b-form-textarea
                :formatter="capitalizeAll"
                id="faultyGoods"
                name="faultyGoods"
                v-model="stockInDetails.faultyGoods"
              ></b-form-textarea>
            </b-col>
          </b-row>

          <div
            class="mt-5 py-2 table-responsive"
            style="background-color: beige"
            v-if="itemArrayShow.length > 0"
          >
            <h5 class="ml-2 py-2"><b>Itemized Stock Details</b></h5>
            <table id="stockIntable" class="table table-bordered">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <!-- <th>Item Code</th> -->
                  <th>Item Name</th>
                  <th>Quantity In PO</th>
                  <th>Rate Per Unit In PO</th>
                  <th>unit</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in itemArrayShow" :key="index">
                  <td>{{ index + 1 }}</td>
                  <!-- <td>{{item.itemCode}}</td> -->
                  <td>{{ item.itemName }}</td>
                  <td>{{ item.itemQuantity }}</td>
                  <td>{{ item.po_ratePerUnit }}</td>
                  <td>{{ item.unit }}</td>

                  <td>
                    <b-col v-if="item.itemQuantityReceived == ''">
                      <b-col md="4">
                        <label>Receiving Status</label>
                        <model-list-select
                          :list="ReceivingStatusList"
                          v-model="item.received_list"
                          id="ReceivedStatus"
                          option-value="RVal"
                          option-text="RText"
                          placeholder="Select Status"
                          @input="validateSubItemFlag(item)"
                        ></model-list-select>
                        <span class="error" v-if="!item.received_list">{{
                          received_listError
                          }}</span>
                        <!-- <span class="error" v-if="item.received_list_err">{{
                          item.received_list_err
                        }}</span> -->
                      </b-col>

                      <b-col md="4" v-if="item.received_list == 'partiallyReceived'">
                        <label>Partially-Received Quantity</label>
                        <b-form-input
                          v-model="item.partially_received_quantity"
                          class="mr-2 mb-2"
                          id="PRQuantity"
                          name="PRQuantity"
                          type="number"
                          :min="1"
                          :max="item.itemQuantity"
                        ></b-form-input>
                        <span
                          class="error"
                          v-if="
                            !item.partially_received_quantity ||
                            item.partially_received_quantity == '0'
                          "
                          >{{ partiallyReceivedQuantityError }}</span
                        >
                      </b-col>
                    </b-col>

                    <b-col class="mt-2 ml-4" v-else>
                      <h5 class="success">
                        Items <b class="warning">{{ item.received_list }}</b> & Stocked In
                      </h5>
                      <span
                        class="success"
                        v-if="item.received_list == 'partiallyReceived'"
                      >
                        Partially Received Quantity:
                        <b class="warning">{{ item.partially_received_quantity }}</b>
                      </span>
                    </b-col>

                    <b-col class="ml-5" v-if="item.unit == 'pcs'">
                      <b-row class="mt-4">
                        <b-button
                          v-if="
                            item.received_list == 'partiallyReceived' ||
                            item.received_list == 'received'
                          "
                          @click="
                            openQuantityModal(
                              item.poItemId,
                              item.itemQuantity,
                              item.itemId,
                              item.poOrderId,
                              item.received_list,
                              item.partially_received_quantity
                            )
                          "
                          variant="primary"
                          id="quantityDetailsButton"
                          size="sm"
                        >
                          Details Per Quantity
                        </b-button>
                      </b-row>

                      <b-row>
                        <span
                          class="error"
                          v-if="
                            (item.received_list == 'partiallyReceived' ||
                              item.received_list == 'received') &&
                            item.itemQuantityReceived == '' &&
                            !validateSubItemComplete &&
                            item.unit == 'pcs'
                          "
                          ><b>{{ detailsPerQtyErr }}</b></span
                        >
                      </b-row>
                    </b-col>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <b-modal
            ref="subItemModal"
            no-close-on-esc
            no-close-on-backdrop
            title="Quantity Details"
            size="xl"
            centered
            hide-footer
          >
            <b-row class="mb-2 ml-3">
              <label>Vendor Name:</label>
              <b-col md="3">
                <b-form-input
                  disabled
                  class="pull-left"
                  v-model="vendorNameDisplay"
                ></b-form-input>
              </b-col>

              <label>Po Date:</label>
              <b-col md="3">
                <b-form-input
                  disabled
                  class="pull-left"
                  :formatter="capitalizeAll"
                  name="ModalPoDate"
                  v-model="stockInDetails.poDate"
                ></b-form-input>
              </b-col>

              <label>Po Number:</label>
              <b-col md="3">
                <b-form-input
                  disabled
                  class="pull-left"
                  :formatter="capitalizeAll"
                  id="subItem_poNumber"
                  name="subItem_poNumber"
                  v-model="subItem_poNumber"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>

            <table class="table table-responsive">
              <thead>
                <tr>
                  <th>Sn.</th>
                  <th>Sub-Item Name</th>
                  <th>Serial Number</th>
                  <th>Installation Date</th>
                  <th>Manufacturing Date</th>
                  <th>Expiry Date</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(row, index) in tableRows" :key="index">
                  <td>{{ index + 1 }}</td>

                  <td>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="sub_item_name"
                      name="sub_item_name"
                      v-model="row.sub_item_name"
                      type="text"
                    ></b-form-input>
                    <span class="error" v-if="!row.sub_item_name">{{
                      sub_item_nameError
                    }}</span>
                  </td>

                  <td>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="sub_item_code"
                      name="sub_item_code"
                      v-model="row.sub_item_code"
                      type="text"
                    ></b-form-input>
                    <span class="error" v-if="!row.sub_item_code">{{
                      sub_item_codeError
                    }}</span>
                  </td>

                  <td>
                    <date-picker
                      :format="selectDateFormat"
                      lang="en"
                      v-model="row.installation_date"
                      id="Date"
                    ></date-picker
                    ><br />
                    <!-- <span class="error" v-if="!row.installation_date">{{installation_dateError}}</span> -->
                  </td>

                  <td>
                    <date-picker
                      :format="selectDateFormat"
                      lang="en"
                      v-model="row.manufacture_date"
                      id="Date"
                      @input="emptyExpiryDate(row)"
                    ></date-picker
                    ><br />
                    <!-- <span class="error" v-if="!row.manufacture_date">{{manufacture_dateError}}</span> -->
                  </td>

                  <td>
                    <date-picker
                      :format="selectDateFormat"
                      lang="en"
                      v-model="row.expiry_date"
                      id="Date"
                      :not-before="row.manufacture_date"
                    ></date-picker
                    ><br />
                    <!-- <span class="error" v-if="!row.expiry_date">{{expiry_dateError}}</span> -->
                  </td>

                  <td>
                    <md-switch
                      :id="'approval' + index"
                      name="approval"
                      class="md-primary"
                      :value="row.is_active == 1 ? true : false"
                      @change="activateQuantity(row)"
                    >
                    </md-switch>
                  </td>
                </tr>
              </tbody>
            </table>

            <b-row class="pull-right mr-2">
              <b-button @click="submitQuantityModal()" variant="primary" class="mr-3"
                >Submit</b-button
              >
              <b-button @click="closeQuantityModal()" variant="danger" class="mr-3"
                >Close</b-button
              >
            </b-row>
          </b-modal>

          <b-row>
            <b-col md="12">
              <md-button
                class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                @click="addRefuelStation"
                id="addButtonLoader"
                >{{ editVar.Inputval }}</md-button
              >
              <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
            </b-col>
          </b-row>
        </div>
      </md-card-content>
    </md-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
      @close="onClose"
    ></md-dialog-alert>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop1"
      @close="onClose1"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";
import CommonService from "../../../services/CommonService.js";

export default {
  beforeMount() {
    if (globalPermissionStatus("Maintanence")) {
      this.$store.dispatch("setCurrentRoute", "/stockIn/");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
    this.$store.dispatch(
      "commonDropdownMaster/setAllTallyVendorDDList",
      JSON.stringify({
        itemCode: "All_Vendor_List",
        Filter: { statusFilter: "1" },
        type: "Normal",
      })
    );
  },
  data() {
    return {
      tableRows: [],
      remainingQuantity: "",
      fetchedQuantityDetails: [],

      detailsPerQtyErr: "",
      validateSubItemComplete: true,
      subItem_poNumber: "",

      sub_item_nameError: "",
      sub_item_codeError: "",
      installation_dateError: "",
      manufacture_dateError: "",
      expiry_dateError: "",
      quantityPoItemId: "",
      quantityItemId: "",
      quantityPoOrderId: "",
      itemQty: "",

      selectDateFormat,
      isLoading: false,
      qualityList: [
        {
          qVal: "yes",
          qText: "Yes",
        },
        {
          qVal: "no",
          qText: "No",
        },
      ],
      MaintainList: [
        {
          MVal: "transport",
          MText: "Transport",
        },
        {
          MVal: "yard",
          MText: "Yard",
        },
        {
          MVal: "office",
          MText: "Office",
        },
      ],

      ReceivingStatusList: [
        {
          RVal: "received",
          RText: "Received",
        },
        {
          RVal: "partiallyReceived",
          RText: "Partially Received",
        },
        {
          RVal: "notReceived",
          RText: "Not Received",
        },
      ],

      received_listError: "",
      partiallyReceivedQuantityError: "",
      quantityRequiredError: "",
      quantityRequired: false,

      alert: {
        content:
          this.$sessionsStorage.get("editStockInId") != "" &&
          this.$sessionsStorage.get("editStockInId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      showMoreNew: false,
      poNumberAll: {},
      itemModal: {
        itemInStock: "",
        itemId: "",
        stockInId: "",
        itemCode: "",
        itemName: "",
        unit: "",
        ratePerUnit: "",
        itemQuantity: "",
        totalAmount: "",
      },

      stockInDetails: {
        poItemId: "",
        poOrderId: "",
        stockInId: "",
        maintenanceType: "",
        itemId: "",
        stockInDate: "",
        location: "",
        addedByPerson: "",
        poDate: "",
        poNumber: "",
        uploadPoDoc: "",
        vendorName: "",
        invoiceNo: "",
        invoiceAmount: "",
        specificPoDetail: "",
        stockReceivedDate: "",
        // stockReceivedDate: stockReceivedDate == "1970-01-01 05:30:00" ? '' : '',
        stockCheckedBy: "",
        stockReceivedBy: "",
        qualityCheck: "",
        goodsStatus: "",
        faultyGoods: "",
      },

      vendorNameDisplay: "",

      validate: true,

      stockInDateError: "",
      maintenanceTypeError: "",
      locationError: "",
      addedByPersonError: "",
      departmentError: "",
      poDateError: "",
      vendorNamError: "",
      invoiceNoError: "",
      invoiceAmountError: "",
      goodsStatusError: "",
      qualityCheckError: "",
      stockReceivedDateError: "",
      stockReceivedByError: "",
      stockCheckedByError: "",

      employeeMaster: [
        {
          employeeName: "ajit",
        },
      ],
      locationMaster: [
        {
          pickupLocation: "mumbai",
        },
      ],
      vendorMaster: [],
      poMaster: [{ maintenanceType: "transport" }],
      departmentMaster: [],

      itemDetail: [
        {
          itemCode: "ajit",
        },
      ],
      locationDetail: [{}],
      dapartmentDetail: [],
      vendorDetail: [],
      itemArrayShow: [],
      itemNameError: "",
      ratePerUnitError: "",
      itemQuantityError: "",
      itemCodeError: "",

      editVar: {
        Inputval:
          this.$sessionsStorage.get("editStockInId") != "" &&
          this.$sessionsStorage.get("editStockInId") != undefined
            ? "Update"
            : "Submit",
        FormVal:
          this.$sessionsStorage.get("editStockInId") != "" &&
          this.$sessionsStorage.get("editStockInId") != undefined
            ? "Update"
            : "New",
      },
    };
  },
  watch: {
    itemArrayShow: {
      deep: true,
      handler(newVal, oldVal) {
        newVal.forEach((item) => {
          if (item.received_list !== "partiallyReceived") {
            item.partially_received_quantity = "";
          }
        });
      },
    },

    poNumberAll: {
      handler: function (newVal, oldVal) {
        this.poCallback(newVal);
      },
      deep: true,
    },
  },
  mounted() {
    // this.JqueryFun();
  },
  beforeDestroy() {
    this.$sessionsStorage.set("editStockInId", "");
    this.$sessionsStorage.set("editPOId", "");
  },
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    CommonService,
  },

  computed: {
    viewDocument() {
      return this.stockInDetails.uploadPoDoc.split(",");
    },

    itemMasterList() {
      return this.itemDetail;
    },
    locationMasterList() {
      return this.locationMaster;
    },
    poMasterList() {
      return this.poMaster;
    },
    employeeMasterList() {
      return this.employeeMaster;
    },
  },
  methods: {
    activateQuantity(item, index) {
      this.itemObj = item;
      this.indexNew = index;

      this.itemObj.is_active = this.itemObj.is_active == 1 ? true : false;
      let paylod = {
        tableName: "po_sub_item",
        tableId: "po_sub_item_id",
        tableIsActive: "is_active",
        value1: this.itemObj.is_active,
        tableVal: item.po_sub_item_id,
        isMailSend: "No",
        manual: "No",
      };
    },

    validateSubItemFlag(item) {
      console.log(item);
      if (item.received_list == "received" || item.received_list == "partiallyReceived") {
        if (item.unit == "pcs") {
          this.validateSubItemComplete = false;
        } else {
          this.validateSubItemComplete = true;
        }
      } else if (item == "notReceived") {
        this.validateSubItemComplete = true;
      }
    },

    openQuantityModal(
      poItemId,
      itemQuantity,
      itemId,
      poOrderId,
      received_list,
      partially_received_quantity
    ) {
      console.log("Salil poItemId", poItemId, received_list, itemQuantity);
      // const newQuantity = previousQuantity - this.tableRows.length;
      console.log("PS poItemId", received_list);
      this.quantityPoItemId = poItemId;
      this.quantityItemId = itemId;
      this.quantityPoOrderId = poOrderId;
      this.itemQty = itemQuantity;
      this.subItem_poNumber = this.stockInDetails.poNumber;
      let quantity = parseInt(itemQuantity);
      if (received_list == "partiallyReceived") {
        this.itemQty = partially_received_quantity;
        quantity = parseInt(partially_received_quantity);
      }
      // alert(this.itemQty);
      this.$refs["subItemModal"].show();

      this.tableRows = [];

      if (quantity > 0) {
        for (let i = 0; i < quantity; i++) {
          let obj = {
            sub_item_name: "",
            sub_item_code: "",
            installation_date: "",
            manufacture_date: "",
            expiry_date: "",
            is_active: true,
            fk_item_id: itemId,
            po_sub_item_id: "",
            fk_po_order_id: poOrderId == null ? 0 : poOrderId,
            fk_po_item_id: poItemId,
          };
          this.tableRows.push(obj);
        }
      }
      this.getSubItemList(poItemId);
    },

    closeQuantityModal() {
      this.$refs["subItemModal"].hide();
    },

    getSubItemList(poItemId) {
      let payload = {
        view: "subItem_list",
        poItemId: poItemId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewPoItems.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.Quantity_detail_list.length > 0) {
              this.tableRows = data.Quantity_detail_list;
              this.remainingQuantity = this.itemQty - this.tableRows.length;

              if (this.remainingQuantity > 0) {
                for (let i = 0; i < this.remainingQuantity; i++) {
                  this.tableRows.push({
                    sub_item_name: "",
                    sub_item_code: "",
                    installation_date: "",
                    manufacture_date: "",
                    expiry_date: "",
                    is_active: true,
                    fk_item_id: this.quantityItemId,
                    po_sub_item_id: "",
                    fk_po_order_id:
                      this.quantityPoOrderId == null ? 0 : this.quantityPoOrderId,
                    fk_po_item_id: this.quantityPoItemId,
                  });
                }
              }
            }
          }
        })
        .catch((error) => {});
    },

    validateQuantiyModal() {
      let validate_new = true;

      let i = 0;
      let errCount = 0;
      let MainARR = this.tableRows;

      for (let j = 0; j < MainARR.length; j++) {
        if (MainARR[j].sub_item_name == "") {
          this.sub_item_nameError = "Name Required";
          validate_new = false;
          ++errCount;
          break;
        } else {
          this.sub_item_nameError = "";
          validate_new = true;
        }

        if (MainARR[j].sub_item_code == "") {
          this.sub_item_codeError = "Series Required";
          validate_new = false;
          ++errCount;
          break;
        } else {
          this.sub_item_codeError = "";
          validate_new = true;
        }

        // if (MainARR[j].installation_date == "") {
        //   this.installation_dateError = "Installation Date Required";
        //   validate_new = false;
        //   ++errCount;
        //   break;
        // } else {
        //   this.installation_dateError = "";
        //   validate_new = true;
        // }

        // if (MainARR[j].manufacture_date == "") {
        //   this.manufacture_dateError = "Manufacture Date Required";
        //   validate_new = false;
        //   ++errCount;
        //   break;
        // } else {
        //   this.manufacture_dateError = "";
        //   validate_new = true;
        // }

        // if (MainARR[j].expiry_date == "") {
        //   this.expiry_dateError = "Expiry Date Required";
        //   validate_new = false;
        //   ++errCount;
        //   break;
        // } else {
        //   this.expiry_dateError = "";
        //   validate_new = true;
        // }
      }

      if (errCount > 0) {
        this.validate = false;
        this.validateSubItemComplete = false;
      } else {
        this.validate = true;
        this.validateSubItemComplete = true;
      }

      if (validate_new != true) {
        this.validate = false;
        this.validateSubItemComplete = false;
      } else {
        this.validate = true;
        this.validateSubItemComplete = true;
      }
    },

    submitQuantityModal() {
      this.validateQuantiyModal();
      this.doLoadingClose();

      // console.log("Salil itemid", this.quantityItemId);
      // console.log("Salil poitemid", this.quantityPoItemId);

      if (this.quantityItemId != "") {
        this.tableRows["fk_item_id"] = this.quantityItemId;
      } else {
        this.tableRows["fk_item_id"] = "";
      }

      if (this.quantityPoItemId != "") {
        this.tableRows["fk_po_item_id"] = this.quantityPoItemId;
      } else {
        this.tableRows["fk_po_item_id"] = "";
      }

      let payload = {
        tableRows: this.tableRows,
        view: "Quantity_Details",
      };

      if (this.validate != false) {
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Maintenance/poItems.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if (status == 200 && data) {
              this.quantityPoItemId += "" + data.Id + ",";

              Object.keys(this.tableRows).map((x) => {
                this.tableRows[x] = "";
              });

              this.isLoading = false;
              this.closeQuantityModal();
            }
          })
          .catch((error) => {});
      }
    },

    emptyExpiryDate(row) {
      const rowIndex = this.tableRows.findIndex((r) => r === row);

      if (this.tableRows[rowIndex].expiry_date) {
        this.tableRows[rowIndex].expiry_date = "";
      }
    },

    "item.received_list": function (newVal, oldVal) {
      if (
        oldVal === "partiallyReceived" &&
        (newVal === "received" || newVal === "notReceived")
      ) {
        this.item.partially_received_quantity = "";
      }
    },

    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    showMore() {
      if (this.showMoreNew == false) {
        this.showMoreNew = true;
      } else {
        this.showMoreNew = false;
      }
    },
    poCallback(item1) {
      console.log(item1);
      this.isLoading = true;
      this.stockInDetails.poNumber = item1.poOrderSeries;
      this.stockInDetails.maintenanceType = item1.maintenanceType;
      this.stockInDetails.poDate = item1.poDate;
      this.stockInDetails.specificPoDetail = item1.specificPoDetail;
      this.stockInDetails.location = item1.location;
      this.stockInDetails.vendorName = item1.vendorName;
      this.stockInDetails.poOrderId = item1.poOrderId;

      this.itemView(item1.poItemId);
      this.isLoading = false;
    },
    onClose: {},

    finalAmount() {
      let amount =
        parseFloat(this.itemModal.ratePerUnit) * parseFloat(this.itemModal.itemQuantity);
      this.itemModal.totalAmount = amount;
    },
    JqueryFun() {
      return $(function () {
        return $("#stockIntable").DataTable();
      });
    },

    getData() {
      this.doLoading();
      let vehicle_drive = {
        itemCode: "itemCode",
        serviceEstimationId: "",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/fetchToStockIn.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.itemDetail = data.itemDetail;
            this.employeeMaster = data.employeeMaster;
            this.locationMaster = data.locationMaster;
            this.vendorMaster = data.vendorMaster;
            if (data.poDetail.length > 0) {
              this.poMaster = data.poDetail;
            } else {
              this.poMaster = [];
            }
            if (data.departmentMaster.length > 0) {
              this.departmentMaster = data.departmentMaster;
            }
            if (data.UserDetail.length > 0) {
              this.stockInDetails.addedByPerson = data.UserDetail[0].employeeName;
            }
            // alert(this.$sessionsStorage.get("editPOId"))
            // alert(this.$sessionsStorage.get("editStockInId"))
            if (
              this.$sessionsStorage.get("editPOId") != "" &&
              this.$sessionsStorage.get("editPOId") != undefined &&
              this.$sessionsStorage.get("editStockInId") != undefined &&
              this.$sessionsStorage.get("editStockInId") != ""
            ) {
              this.viewStockDetail();
            }
            this.doLoadingClose();
          }
        })
        .catch((error) => {});
    },

    onClose(type) {
      this.$router.push({
        path: "/viewStockIn",
      });
    },
    onClose1(poID) {
      this.itemArrayShow = [];
      let payload = {
        poItemId: poID,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewPoItems.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.itemArray.length > 0) {
              this.itemArrayShow = data.itemArray;
              this.itemArrayShow.forEach((item) => {
                item.received_list_err = "";
              });
              console.log("received_list_err1", this.itemArrayShow);
            }

            // this.JqueryFun();

            this.getData();
          }
        })
        .catch((error) => {});
    },

    itemMasterFilter(list, query) {
      return this.itemDetail.filter((x) => {
        return x.itemCode.toLowerCase().includes(query.toLowerCase());
      });
    },

    locationMasterFilter(list, query) {
      return this.locationMaster.filter((x) => {
        return x.pickupLocation.toLowerCase().includes(query.toLowerCase());
      });
    },
    poMasterFilter(list, query) {
      return this.poMaster.filter((x) => {
        return x.poOrderSeries.toLowerCase().includes(query.toLowerCase());
      });
    },

    employeeMasterFilter(list, query) {
      return this.employeeMaster.filter((x) => {
        return x.employeeName.toLowerCase().includes(query.toLowerCase());
      });
    },

    previousStockInView() {
      this.$router.push({
        path: "/viewStockIn",
      });
    },
    openItemDialog() {
      this.$refs["dialog"].open();
    },
    getVendorDetails(item) {
      console.log("item=>", item);
      this.stockInDetails.addedByPerson = item.addedByPerson;
      this.stockInDetails.maintenanceType = item.maintenanceType;
      this.stockInDetails.poDate = item.poDate;
      this.stockInDetails.vendorName = item.vendorName;
      this.vendorNameDisplay = item.vendorNameDisplay;
      console.log("stockInDetails=>", this.stockInDetails);
    },
    viewStockDetail() {
      let payload = {
        view: "view",
        stockInId: this.$sessionsStorage.get("editStockInId"),
        poOrderId: this.$sessionsStorage.get("editPOId"),
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewStockIn.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (data.clientId != "" && status == 200 && data) {
            Object.keys(data.itemArray[0]).map((x) => {
              this.stockInDetails[x] = data.itemArray[0][x] || "";
            });

            this.vendorNameDisplay = data.itemArray[0].vendor;

            let stockReceivedDate =
              this.stockInDetails.stockReceivedDate == "1970-01-01 05:30:00" ||
              undefined ||
              null
                ? null
                : this.stockInDetails.stockReceivedDate;
            this.stockInDetails.stockReceivedDate = stockReceivedDate;

            // this.JqueryFun();
            this.itemView(this.stockInDetails.poItemId);
          }
        })
        .catch((error) => {});
    },
    itemView(poID) {
      this.isLoading = true;
      this.itemArrayShow = [];

      let payload = {
        poItemId: poID,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewPoItems.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.itemArray.length > 0) {
              this.itemArrayShow = data.itemArray;
              this.itemArrayShow.forEach((item) => {
                item.received_list_err = "";
              });
              console.log("received_list_err2", this.itemArrayShow);
            }

            this.isLoading = false;
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },

    validateJobOrder() {
      let validate_new = true;

      if (this.stockInDetails.location == "") {
        $("#location").focus();
        this.locationError = "Enter Location";
        validate_new = false;
      }

      if (this.stockInDetails.vendorName == "") {
        // $("#vendorName").focus();
        this.vendorNamError = "Select Vendor";
        validate_new = false;
      }

      if (this.stockInDetails.invoiceNo == "") {
        $("#invoiceNo").focus();
        this.invoiceNoError = "Enter Invoice No.";
        validate_new = false;
      }

      if (this.stockInDetails.invoiceAmount == "") {
        $("#invoiceAmount").focus();
        this.invoiceAmountError = "Enter Invoice Amount";
        validate_new = false;
      }

      if (!this.stockInDetails.stockReceivedDate) {
        $("#Date").focus();
        this.stockReceivedDateError = "Select Stock Received Date";
        validate_new = false;
      }

      if (this.stockInDetails.stockReceivedBy == "") {
        $("#stockReceivedBy").focus();
        this.stockReceivedByError = "Select Stock Received By";
        validate_new = false;
      }

      if (this.stockInDetails.stockCheckedBy == "") {
        $("#stockCheckedBy").focus();
        this.stockCheckedByError = "Select Stock Checked By";
        validate_new = false;
      }

      if (!this.stockInDetails.stockInDate) {
        $("#stockInDate").focus();
        this.stockInDateError = "Select Stock-In date";
        validate_new = false;
      }

      if (this.stockInDetails.maintenanceType == "") {
        $("#maintenanceType").focus();
        this.maintenanceTypeError = "Select Maintenance Type";
        validate_new = false;
      }

      if (this.stockInDetails.qualityCheck == "") {
        $("#qualityCheck").focus();
        this.qualityCheckError = "Enter quality check";
        validate_new = false;
      }

      if (this.stockInDetails.goodsStatus == "") {
        $("#goodsStatus").focus();
        this.goodsStatusError = "Enter your good status";
        validate_new = false;
      }

      let i = 0;
      let errCount = 0;
      let MainARR = this.itemArrayShow;

      for (let j = 0; j < MainARR.length; j++) {
        if (
          MainARR[j].received_list == "" ||
          MainARR[j].received_list == null ||
          MainARR[j].received_list == "null" ||
          MainARR[j].received_list == undefined ||
          MainARR[j].received_list == "undefined"
        ) {
          this.received_listError = "Received Status is required";
          this.itemArrayShow[j].received_list_err = "Received Status is required";
          validate_new = false;
          ++errCount;
          break;
        } else {
          this.received_listError = "";
          this.itemArrayShow[j].received_list_err = "";
          validate_new = true;
        }

        if (
          MainARR[j].partially_received_quantity == "" &&
          MainARR[j].received_list == "partiallyReceived"
        ) {
          this.partiallyReceivedQuantityError = "Quantity is required";
          $("#PRQuantity").focus();
          validate_new = false;
          ++errCount;
          break;
        } else {
          this.partiallyReceivedQuantityError = "";
          validate_new = true;
        }

        if (MainARR[j].partially_received_quantity == "0") {
          this.partiallyReceivedQuantityError = "Quantity cannot be 0";
          $("#PRQuantity").focus();
          validate_new = false;
          ++errCount;
          break;
        } else {
          this.partiallyReceivedQuantityError = "";
          validate_new = true;
        }
      }

      if (errCount > 0) {
        this.validate = false;
      } else {
        this.validate = true;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addRefuelStation() {
      this.validateJobOrder();

      let stockReceivedDate =
        this.stockInDetails.stockReceivedDate == "1970-01-01 05:30:00" ||
        undefined ||
        null
          ? null
          : this.stockInDetails.stockReceivedDate;
      this.stockInDetails.stockReceivedDate = stockReceivedDate;

      this.detailsPerQtyErr = "Fill Sub Item Details here to proceed";
      console.log(this.validate);
      // console.log("this.itemArrayShow=>", this.itemArrayShow);
      // return false;

      if (this.validate == true && this.validateSubItemComplete == true) {
        this.detailsPerQtyErr = "";
        this.stockInDetails["itemArrayShow"] = this.itemArrayShow;

        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Maintenance/addStockIn.php`,
          data: JSON.stringify(this.stockInDetails),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");

            this.$refs["addPop"].open();
          })

          .catch((error) => {});
      }
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 16% !important;
}
.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.warning {
  color: orangered;
}
.success {
  color: green;
}
.md-dialog-container.HereDialog.md-theme-default {
  z-index: 1;
}

.md-dialog-container.HereDialog.md-theme-default .md-dialog {
  width: 50%;
  height: 50%;
}
.md-select-content {
  z-index: 999999999;
}
.marg-top {
  margin-top: 0%;
}
</style>



// WEBPACK FOOTER //
// stockIn.vue?2ae0b02d